import en from "./en/translations.json";
import pl from "./pl/translations.json";

const useTranslation = (code = "pl") => {
  const languages = { en, pl };
  const t = (key) => languages[code]?.[key] || key;
  return { t };
};

export default useTranslation;
